import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P00045TimeZoneTypeEnum } from '../../../P00045/P00045TimeZoneTypeEnum';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { P0003605SensContactEnum } from '../../Enum/P0003605SensContactEnum';
import { P00032DetectionSensContactModalComponent } from '../../../P00032/Modal/p00032-detection-sens-contact-modal/p00032-detection-sens-contact-modal.component';
import { P0003605DetectionFinBidonModalComponent } from '../../Modal/p0003605-detection-fin-bidon-modal/p0003605-detection-fin-bidon-modal.component';
import { P00032SensContactEnum } from '../../../P00032/Enum/P00032SensContactEnum';

@Component({
  selector: 'app-p0003605-installation-detecteur-fin-bidon',
  templateUrl: './p0003605-installation-detecteur-fin-bidon.component.html',
  styleUrls: ['./p0003605-installation-detecteur-fin-bidon.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    TranslatePipe,
    SwitchConfigurationComponent,
    LargedLinkComponent,
  ],
})
export class P0003605InstallationDetecteurFinBidonComponent implements OnInit {
  private modalController: ModalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goDetectionModal(value: number) {
    if (value != 99) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionChlore_Installation,
        'icISensContactFinBidon',
        value,
        null,
      );
      return;
    }

    const modal = await this.modalController.create({
      component: P0003605DetectionFinBidonModalComponent,
      componentProps: {
        title: 'P0003605.installation.contact',
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionChlore_Installation,
        'icISensContactFinBidon',
        data.value,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00045TimeZoneTypeEnum = P00045TimeZoneTypeEnum;
  protected readonly P0003605SensContactEnum = P0003605SensContactEnum;
  protected readonly P00032SensContactEnum = P00032SensContactEnum;
}
